import  ReactGA from 'react-ga4'
import { useLocation } from "react-router-dom"
import { useEffect } from 'react'

const GA = () => {
    useEffect(()=>{
        ReactGA.initialize([{trackingId: "G-KVM82T9BCJ"},{trackingId: "UA-132563689-9"}]);
    })

    const location = useLocation();

    useEffect(()=>{
        ReactGA.send({
            hitType: "pageview", 
            page: location.pathname + location.search
        })
    },[location])

    return null;
}

export default GA;
